import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=3a465f5c&scoped=true"
import script from "./DemoPage.vue?vue&type=script&lang=ts"
export * from "./DemoPage.vue?vue&type=script&lang=ts"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=3a465f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a465f5c",
  null
  
)

export default component.exports